import { extend } from "../core/options"
import jsVectorMap from 'jsvectormap'
import vmSettings from '../settings/vectorMap.json'

export class vMap
{
    constructor(options)
    {
        this.options = extend(true,
            {
                selector: '#map',
                map:      'germany',
                regions:  null,
                colors: {
                    "blue1": "#137ec9",
                    "blue2": "#2b92da",
                    "blue3": "#5baae1"
                }
            }, options ||{})

        this.selector = document.querySelector(this.options.selector)
        this.regions  = this.options.regions

        if (!this.selector || !this.regions)
            return

        this.current = []
        this.series  = []

        this._init()
    }

    _init()
    {
        this.currentPath = this._getRelativePath()

        this._extractSeries()
        this._buildMap()
    }

    _extractSeries()
    {
        let selected = false

        Object.entries(this.regions).forEach((region) => {
            this.series[region[0]] = region[1].color || null

            // Set the current region
            if (!selected && this.currentPath === region[1].url)
            {
                this.current.push(region[0])
                selected = true
            }
        })
    }

    _getRelativePath()
    {
        return (window.location.pathname).replace(/^\/+/g, '')
    }

    _onRegionTooltipShow(e, el, code)
    {
        if (!this.regions[code])
            return

        if (!!this.regions[code].text)
            el._tooltip.innerHTML = this.regions[code].text
        else
            e.preventDefault()
    }

    _onRegionClick(code)
    {
        if ((undefined !== this.regions[code].url) && !!this.regions[code].url)
            window.location.href = this.regions[code].url
    }

    _buildMap()
    {
        const regions = this.regions;

        try {
            const map = new jsVectorMap({
                selector: this.selector,
                map: this.options.map,
                regionsSelectable: vmSettings.regionsSelectable,
                regionsSelectableOne: vmSettings.regionsSelectableOne,
                onRegionTooltipShow: (e, el, code) => {
                    this._onRegionTooltipShow(e, el, code)
                },
                onRegionClick: (e, code) => {
                    this._onRegionClick(code)
                },
                regionStyle: vmSettings.regionStyle,
                labels: {
                    regions: {
                        render(code) {
                            if (undefined !== regions[code])
                                return regions[code].label || code
                            return code
                        },
                        offsets(code) {
                            if (undefined !== regions[code])
                                return regions[code].offsets || [0,0]
                            return [0,0]
                        }
                    }
                },
                regionLabelStyle: vmSettings.regionLabelStyle,
                series: {
                    regions: [{
                        attribute: vmSettings.series.attribute,
                        scale: this.options.colors,
                        values: this.series
                    }]
                },
                selectedRegions: this.current,
                onLoaded(map) {
                    window.addEventListener('resize', () => {
                        map.updateSize()
                    })
                }
            })
        } catch (e) {}
    }
}
